$(document).ready(function(){
  $(".quantity__button").on("click",function(){
    var pdp_qty_value = parseInt($(".product__info-container .product-form__quantity quantity-input input").val());
    console.log("pdp_qty_value:--",pdp_qty_value);
    var pdp_ticket = $(".price_with_cst_data .cus_ticket").data("ticket");
    $(".cus_ticket").text(pdp_ticket*pdp_qty_value);
    $("#form_ticket").val(pdp_ticket*pdp_qty_value+" Tickets");
    // console.log(pdp_ticket*pdp_qty_value);
  });
  
  jQuery.getJSON('/cart.js', function(cart) {
    console.log("in custom.js")
     let totalTickets = 0;
   // now have access to Shopify cart object
  $(".cart-item").each(function(){
   var total_ticket = $(this).find(".cus_tickitnumber").data("ticket_no");
      if (!isNaN(total_ticket)) {
        totalTickets += parseInt(total_ticket, 10);
    }
});
    console.log(totalTickets);
          $(".totaal-ticket-count").text(totalTickets+" Tickets");
});
});




$(document).ready(function(){
  $(".cst_pay_btn").on("click",function(){
    $(".cart__checkout-button.button").trigger("click");
  });

 setTimeout(function(){
      const variantJsonScript = document.querySelector('#variant-images-json');
      if (variantJsonScript) {
        const variantImageData = JSON.parse(variantJsonScript.textContent); 
        // console.log(variantImageData.img); 
        const mySwiper = document.querySelector('.swiprt_thumbnail_slider')?.swiper;
         const mian_mySwiper = document.querySelector('.swiper-main-wrapper .swiper')?.swiper;
        if (mySwiper) {
          const slides = mySwiper.slides;
          let targetSlideIndex = -1;
          slides.forEach((slide, index) => {
            const slideImage = slide.getAttribute('data-thumb-media-id'); 
            // console.log("slideImage:--",slideImage,"index:--",index);
            if (slideImage && slideImage.includes(variantImageData.img)) {
              targetSlideIndex = index;
              
            }
          });
          if (targetSlideIndex >= 0) {
            mySwiper.slideTo(targetSlideIndex, 500);

             if (mian_mySwiper) {
                mian_mySwiper.slideTo(targetSlideIndex, 500);
             }
          } 
        }
         }
      },1200);
});